import { getTodaysHoliday, HolidayMode } from '@theme/palettes/getPalette';
import { useStore } from '@store/GlobalStore';
import { useApiEnvStore } from '@utils/api-client';

/**
 * Today's holiday, or null when there isn't one, the user hasn't turned holiday mode on, or the user isn't internal.
 * The opt-in is persisted per browser, not per user, so the internal check keeps it from carrying over to the login
 * page or a broker/customer session on the same machine (they never see the toggle to turn it off).
 */
export const useActiveHoliday = (): HolidayMode | null => {
  const disableHolidayModeFlag = useApiEnvStore((state) => state.disableHolidayModeFlag);
  const isInternalUser = useStore((state) => state.userAuth.isInternalUser);
  return disableHolidayModeFlag || !isInternalUser ? null : getTodaysHoliday();
};
